let currentUser = null;
let version = null;

export const UserUtils = {
    getCurrentUser: () => currentUser,
    getVersion: () => version,
    init: async () =>
    {
        if(version == null) await fetchVersion();

        try
        {
            const response = await fetch('/api/public/me', { credentials: 'include' });

            if(response.ok) currentUser = await response.json();
            else console.error("Unable to retrieve current user! - " + response.status + " - " + response.statusText);
        }
        catch(e)
        {
            console.error("Error retrieving current user!");
        }
    }
}

async function fetchVersion()
{
    try
    {
        const response = await fetch('/api/public/version', { credentials: 'include' });

        if(response.ok)
        {
            version = await response.text();
            console.log("Forge Version is " + version);
        }
        else console.error("Unable to retrieve version! - " + response.status + " - " + response.statusText);
    }
    catch(e)
    {
        console.error("Error retrieving version!");
    }
}